import React, { useState } from 'react'
import { useAuth } from '../../contexts/AuthContext'

const UserProfile = ({ onClose }) => {
  const { user, signOut } = useAuth()
  const [loading, setLoading] = useState(false)

  const handleSignOut = async () => {
    setLoading(true)
    try {
      await signOut()
      onClose()
    } catch (error) {
      console.error('Error signing out:', error)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="auth-modal-overlay" onClick={onClose}>
      <div className="auth-modal" onClick={(e) => e.stopPropagation()}>
        <div className="auth-header">
          <h2>Profile</h2>
          <button className="close-btn" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 14 14" fill="none">
              <path d="M0.355469 1L13.3555 14" stroke="#707070" strokeLinecap="round" />
              <path d="M13 1L-3.13672e-07 14" stroke="#707070" strokeLinecap="round" />
            </svg>
          </button>
        </div>

        <div className="profile-info">
          <div className="profile-item">
            <label>Email:</label>
            <span>{user?.email}</span>
          </div>

          <div className="profile-item">
            <label>User ID:</label>
            <span className="user-id">{user?.id}</span>
          </div>

          <div className="profile-item">
            <label>Email Verified:</label>
            <span className={user?.email_confirmed_at ? 'verified' : 'unverified'}>
              {user?.email_confirmed_at ? 'Yes' : 'No'}
            </span>
          </div>
        </div>

        <button
          onClick={handleSignOut}
          className="auth-btn danger"
          disabled={loading}
        >
          {loading ? 'Signing out...' : 'Sign Out'}
        </button>
      </div>
    </div>
  )
}

export default UserProfile